import React, { useCallback, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useEditController, useNotify, useRefresh } from 'react-admin';

import DeleteButton from '../DeleteButton';
import DetailForm from '../Form/DetailForm';
import TextInputField from '../Form/TextInputField';

import useExportData from '../../utils/useExportData';
import JSONField from '../Form/JSONField';
import AuthField from '../Form/AuthField';
import SendDialog from '../SendDialog';
import config from '../../config';
import { authStore } from '../../authstore';

const T = (props) => {
    const notify = useNotify();
    const refresh = useRefresh();
      const editControllerProps = useEditController({
          ...props,
          mutationMode: 'pessimistic',
          onFailure: () => {
            refresh();
          },
          onSuccess: () => {
            refresh();
          },
        });
      const onEdit = (data) => {
          console.log(data.updated_src);
          editControllerProps.save({body: data.updated_src}, {
              onSuccess: () => {
                  notify('Erfolgreich gespeichert!', 'success');
                  refresh();
              },
              
          });
      };
  
      const onAdd = (data) => {
          console.error(data);
      };
    return (
        <>
            <div className="flex row">
                <div className="flex-item">
                    <DetailForm formLabel="Info" boxClassName="contact" {...props} noEditMode>
                        <TextInputField source="endpoint" label="Endpunkt" disabled />
                        <AuthField />
                        <TextInputField source="resubmission.leadId" label="Lead ID" disabled />
                    </DetailForm>
                </div>
            </div>
            <div className="flex row">
                <div className="flex-item">
                    <DetailForm formLabel="Anfrage" boxClassName="contact" {...props} noEditMode>
                        <JSONField source="body" label="Anfrage" onEdit={onEdit} onAdd={onAdd} />
                    </DetailForm>
                </div>
                <div className="flex-item">
                    <DetailForm formLabel="Fehler" boxClassName="contact" {...props} noEditMode>
                        <JSONField source="error.errors" label="Anfrage" />
                    </DetailForm>
                </div>
            </div>
        </>
    );
};

export function FailedRequests(props) {
    const [isOpen, setIsOpen] = useState(false);
    const history = useNavigate();
    const editProps = useEditController({ ...props, undoable: false });
    const { exportCallback, viewCallback } = useExportData(editProps.record);
    const notify = useNotify();
    const refresh = useRefresh();
    const leadId = editProps.record?.resubmission?.leadId;

    const submitCallback = useCallback( async (apiKey) => {
        const { endpoint } = editProps.record;

        const url = `${config.API_URL}${endpoint.replace("/api", "")}`.concat(`?resubmission=${editProps.record.id}`);
        
        const response = await fetch(url, {
            method: 'POST',
            body: JSON.stringify(editProps.record.body),
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${apiKey}`
            }
        });
        if(!response.ok) {
            const error = await response.json();
            notify('Fehler beim Senden der Anfrage!', 'error');
            setIsOpen(false);
            refresh();
        } else {
            const token = authStore.get();
            const data = await response.json();
            if(data && typeof data === "object" && data != null && "status" in data && data.status === "ok" && "data" in data && typeof data.data === "object" && data.data != null && "leadId" in data.data) {
                const leadId = data.data.leadId;
                const res = await fetch(`${config.API_URL}/failed-requests/${editProps.record.id}/${leadId}`, { 
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${token}`
                    }
                });
                if(!res.ok) {
                    const error = await res.json();
                    console.error(error);
                } else {
                    notify('Erfolgreich gespeichert!', 'success');
                }
                setIsOpen(false);
                refresh();
            }
        }
    }, [editProps.record]);

    const goBackCallback = useCallback(() => {
        history(-1);
    }, [history]);
    return (
        <div className={'details'}>
            <div className="flex space">
                <h2 className="symbol">Fehlerhafte Anfrage</h2>
                <button onClick={goBackCallback} className="btn btn-border">
                    <i className="icon icon-chevron-left"></i>Zurück
                </button>
            </div>
            <T {...editProps} />
            <SendDialog isOpen={isOpen} onClose={() => setIsOpen(false)} submitCallback={submitCallback} />
            <button className="export" onClick={() => setIsOpen(true)} disabled={!!leadId}>
                Erneut an FPS senden
            </button>
            <button className="export" onClick={exportCallback}>
                Export
            </button>
            <button className="export" onClick={viewCallback}>
                View
            </button>
            {editProps.record && <DeleteButton {...editProps} />}
        </div>
    );
}
